export const options = Symbol("options");
